var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labeled-input-container"},[_c('label',[_vm._t("label"),_vm._v(" "+_vm._s(_vm.label)+" "+_vm._s(_vm.warning)+" ")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }